(function () {
  const CHANGE = '/cart/change.js';

  // Ajusta si quieres
  const DTF_DEBOUNCE_MS = 140;
  const RETRY_DELAY_MS = 250;

  const timers = new Map();     // key -> timeout debounce
  const inFlight = new Map();   // key -> boolean request en curso
  const latestQty = new Map();  // key -> última qty deseada

  function clampQty(v) {
    const n = parseInt(v, 10);
    if (isNaN(n) || n < 0) return 0;
    return n;
  }

  /**
   * Dawn pide "section ids" reales para main-cart-items/footer: los data-id del DOM.
   * cart-icon-bubble se pide por string fijo.
   */
  function getSectionsToRender() {
    const out = [];

    const items = document.getElementById('main-cart-items');
    if (items) {
      out.push({
        id: 'main-cart-items',
        section: items.dataset.id || 'main-cart-items', // fallback por si faltase data-id
        selector: '.js-contents'
      });
    }

    const footer = document.getElementById('main-cart-footer');
    if (footer) {
      out.push({
        id: 'main-cart-footer',
        section: footer.dataset.id || 'main-cart-footer',
        selector: '.js-contents' // CRÍTICO: no tocamos los botones dinámicos
      });
    }

    const bubble = document.getElementById('cart-icon-bubble');
    if (bubble) {
      out.push({
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '' // se reemplaza el nodo completo
      });
    }

    return out;
  }

  function renderSections(sectionsObj, sectionsToRender) {
    if (!sectionsObj || !sectionsToRender || !sectionsToRender.length) return false;

    const parser = new DOMParser();
    const y = window.scrollY;
    let updated = false;

    for (const s of sectionsToRender) {
      const html = sectionsObj[s.section];
      if (!html) continue;

      const container = document.getElementById(s.id);
      if (!container) continue;

      const doc = parser.parseFromString(html, 'text/html');
      const newContainer = doc.getElementById(s.id);
      if (!newContainer) continue;

      // Si hay selector (main-cart-items/footer), solo reemplazamos esa parte
      if (s.selector) {
        const target = container.querySelector(s.selector);
        const source = newContainer.querySelector(s.selector);

        if (target && source) {
          target.innerHTML = source.innerHTML;
          updated = true;

          // En el footer además sincronizamos el estado disabled del checkout (sin reemplazarlo)
          if (s.id === 'main-cart-footer') {
            const oldCheckout = container.querySelector('button[name="checkout"], button#checkout, .cart__checkout-button');
            const newCheckout = newContainer.querySelector('button[name="checkout"], button#checkout, .cart__checkout-button');
            if (oldCheckout && newCheckout) {
              if (newCheckout.hasAttribute('disabled')) oldCheckout.setAttribute('disabled', 'disabled');
              else oldCheckout.removeAttribute('disabled');

              // Aria (por compatibilidad)
              if (newCheckout.hasAttribute('aria-disabled')) {
                oldCheckout.setAttribute('aria-disabled', newCheckout.getAttribute('aria-disabled') || 'true');
              } else {
                oldCheckout.removeAttribute('aria-disabled');
              }
            }
          }
        } else {
          // Fallback MUY conservador:
          // - Para footer: NO reemplazamos todo (para no matar botones dinámicos).
          // - Para items: sí podemos reemplazar todo si hiciera falta.
          if (s.id === 'main-cart-footer') {
            // Intento mínimo: actualizar solo el valor del total si existe
            const oldTotal = container.querySelector('.totals__total-value');
            const newTotal = newContainer.querySelector('.totals__total-value');
            if (oldTotal && newTotal) {
              oldTotal.innerHTML = newTotal.innerHTML;
              updated = true;
            }
          } else {
            container.innerHTML = newContainer.innerHTML;
            updated = true;
          }
        }
      } else {
        // cart-icon-bubble: reemplazo completo
        container.innerHTML = newContainer.innerHTML;
        updated = true;
      }
    }

    // Mantener scroll (evita saltos por cambios de altura)
    if (typeof y === 'number') window.scrollTo(0, y);

 // Re-inicializar lazy thumbs tras re-render
    initDTFThumbLazy();
  
    return updated;
  }

  async function changeLine(key, quantity) {
    const sectionsToRender = getSectionsToRender();

    const payload = { id: key, quantity: quantity };
    if (sectionsToRender.length) {
      payload.sections = sectionsToRender.map(s => s.section);
      payload.sections_url = window.location.pathname;
    }

    const res = await fetch(CHANGE, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    });

    let data = null;
    try {
      data = await res.json();
    } catch (e) {}

    if (!res.ok) {
      const msg =
        data && (data.description || data.message)
          ? (data.description || data.message)
          : 'No se pudo actualizar el carrito.';
      throw new Error(msg);
    }

    if (data && data.sections) {
      const ok = renderSections(data.sections, sectionsToRender);
      if (ok) {
        // Evento útil si algo más escucha cambios del carrito
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: data } }));
        return data;
      }
    }

    // Fallback seguro si por lo que sea no pudimos pintar
    window.location.reload();
    return data;
  }

  function queueChange(key, qty) {
    latestQty.set(key, qty);
    if (timers.has(key)) clearTimeout(timers.get(key));
    timers.set(key, setTimeout(() => flushChange(key), DTF_DEBOUNCE_MS));
  }

  async function flushChange(key) {
    if (inFlight.get(key)) return;

    inFlight.set(key, true);
    const qtyAtStart = latestQty.get(key);

    try {
      await changeLine(key, qtyAtStart);
    } catch (err) {
      const msg = err && err.message ? err.message : '';
      const isNetworkLike =
        (err instanceof TypeError) ||
        /Failed to fetch/i.test(msg) ||
        /NetworkError/i.test(msg);

      if (isNetworkLike) {
        try {
          await new Promise(r => setTimeout(r, RETRY_DELAY_MS));
          await changeLine(key, latestQty.get(key));
        } catch (e2) {
          alert((e2 && e2.message) ? e2.message : 'Error al actualizar.');
        }
      } else {
        alert(msg || 'Error al actualizar.');
      }
    } finally {
      inFlight.set(key, false);

      // Si cambió otra vez durante la request, mandamos el último valor
      const qtyNow = latestQty.get(key);
      if (qtyNow !== qtyAtStart) queueChange(key, qtyNow);
    }
  }

  // Delegación: funciona aunque re-rendericemos main-cart-items
  document.addEventListener('click', (e) => {
    const minus = e.target.closest('[data-dtf-qty-minus]');
    const plus = e.target.closest('[data-dtf-qty-plus]');
    if (!minus && !plus) return;

    const row = e.target.closest('.dtf-cart-item');
    if (!row) return;

    const input = row.querySelector('[data-dtf-qty-input]');
    if (!input) return;

    const key = input.getAttribute('data-line-key');
    if (!key) return;

    const cur = clampQty(input.value);
    const next = minus ? Math.max(0, cur - 1) : (cur + 1);

    // UI inmediata
    input.value = next;

    // Backend con cola
    queueChange(key, next);
  });

  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-dtf-qty-input]');
    if (!input) return;

    const key = input.getAttribute('data-line-key');
    if (!key) return;

    const next = clampQty(input.value);
    queueChange(key, next);
  });
    // ============================
  // DTF thumbs: lazy load + thumb URL
  // ============================
  function dtfThumbUrl(url) {
    if (!url) return url;

    // Solo intentamos “thumb” si viene del CDN de Shopify
    if (!/cdn\.shopify\.com/.test(url)) return url;

    // Shopify CDN suele aceptar width=...
    const sep = url.includes('?') ? '&' : '?';
    return url + sep + 'width=240';
  }

  function initDTFThumbLazy() {
    const imgs = document.querySelectorAll('img[data-dtf-thumb][data-src]');
    if (!imgs.length) return;

    // Evita re-observar imágenes ya inicializadas
    imgs.forEach(img => {
      if (img.dataset.dtfLazyInit === '1') return;
      img.dataset.dtfLazyInit = '1';
    });

    const loadImg = (img) => {
      const raw = img.getAttribute('data-src');
      if (!raw) return;
      img.src = dtfThumbUrl(raw);
      img.removeAttribute('data-src');
    };

    // Si no hay IntersectionObserver, cargamos igual (fallback)
    if (!('IntersectionObserver' in window)) {
      imgs.forEach(loadImg);
      return;
    }

    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        const img = entry.target;
        io.unobserve(img);
        loadImg(img);
      });
    }, { rootMargin: '300px 0px' });

    imgs.forEach(img => {
      if (img.getAttribute('data-src')) io.observe(img);
    });
  }
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDTFThumbLazy);
  } else {
    initDTFThumbLazy();
  }
})();
